export var ONBOARDING_LINK = 'd/gsn-2hb-3tz/fisherman-onboarding-call';
export var GLAMMATIC_ONBOARDING_LINK = 'd/4cd-qxz-tvx/glammatic-onboarding-call';
export var STORYBOOK_TESTING_LINK = 'embed-demo-customer-success/tips-and-tricks-webinar';